
import { computed, defineComponent, PropType, ref, watchEffect } from 'vue';
import { InputElementTypes } from '@/enums';
import NumberInput from '@/components/form-controls/base/NumberInput.vue';
import { firebaseEmptyField } from '@/constants';
import { isNullish } from '@/utils';
import { FirebaseEmptyField } from '@/types';
import { useVModel } from 'vue-composable';

export default defineComponent({
  name: 'DefaultOrCustomValueInput',
  emits: ['update:modelValue'],
  components: {
    NumberInput
  },
  props: {
    modelValue: {
      type: [Number, String] as PropType<number | FirebaseEmptyField | undefined>,
      required: true
    },
    defaultText: {
      type: String
    },
    defaultCustomValue: {
      type: Number,
      required: true
    },
    customText: {
      type: String,
      default: 'Use custom value'
    },
    label: {
      type: String
    },
    horizontal: {
      type: Boolean
    },
    isDefault: {
      type: Boolean
    }
  },
  setup(props) {
    const isComponentStateSet = ref(false);
    const state = useVModel(props, 'modelValue');
    const isModelValueNullishOrEmpty = computed(() => isNullish(state.value) || state.value === firebaseEmptyField);
    const customValue = ref<number | FirebaseEmptyField>();
    const radioValue = ref<'default' | 'custom'>();
    const isRadioValueDefault = computed(() => radioValue.value === 'default');

    // Wait for the actual store value before populating the component values.
    watchEffect(() => {
      if (isComponentStateSet.value || props.isDefault) return;

      isComponentStateSet.value = true;
      customValue.value = state.value;
      radioValue.value = isModelValueNullishOrEmpty.value ? 'default' : 'custom';
    });

    watchEffect(() => {
      if (props.isDefault) return;
      state.value = isRadioValueDefault.value ? firebaseEmptyField : customValue.value;
    });

    return {
      InputElementTypes,
      radioValue,
      customValue,
      isRadioValueDefault
    };
  }
});
